var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M9.214 8.036a1.6 1.6 0 0 0-1.01.357L5.43 6.386a2.2 2.2 0 0 0 0-.772l2.775-2.007a1.608 1.608 0 0 0 2.617-1.25 1.608 1.608 0 1 0-3.151.446L5.034 4.712a2.142 2.142 0 1 0 0 2.577L7.67 9.196a1.608 1.608 0 1 0 3.151.446c0-.887-.72-1.607-1.607-1.607m0-6.375a.697.697 0 1 1 0 1.393.697.697 0 0 1 0-1.393M3.322 7.179A1.18 1.18 0 0 1 2.143 6c0-.65.529-1.179 1.179-1.179S4.5 5.351 4.5 6a1.18 1.18 0 0 1-1.178 1.179m5.892 3.16a.697.697 0 1 1 .001-1.393.697.697 0 0 1 0 1.393"
  })));
};
export default SvgShare;